import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@optools/components/ui/select';
import { ProgramSource } from '@optools/services/operator-gateway/types/generated/graphql';

export interface ProgramSourceSelectProps {
  id?: string;
  onValueChange: (value: string) => void;
  value: string | undefined;
}

export function ProgramSourceSelect({ id, onValueChange, value }: ProgramSourceSelectProps) {
  return (
    <Select defaultValue={ProgramSource.UNKNOWN} value={value} onValueChange={onValueChange}>
      <SelectTrigger className="w-32" id={id}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ProgramSource.FRONTHAUL}>Fronthaul</SelectItem>
        <SelectItem value={ProgramSource.BACKHAUL}>Backhaul</SelectItem>
        <SelectItem value={ProgramSource.UNKNOWN}>None</SelectItem>
        <SelectItem className="pointer-events-none hidden" value={ProgramSource.AUDIO}>
          Audio
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
